import { render, staticRenderFns } from "./metaPage.vue?vue&type=template&id=541486dc&scoped=true&lang=pug"
import script from "./metaPage.vue?vue&type=script&lang=js"
export * from "./metaPage.vue?vue&type=script&lang=js"
import style0 from "./metaPage.vue?vue&type=style&index=0&id=541486dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541486dc",
  null
  
)

export default component.exports